export default __webpack_public_path__ + "static/media/weatherbyshawn@3x.2bc8145e.png";